$bog_blitz_admin_option $mol_list
	rows <= option_content /
	Image_section $mol_row
		sub <= image_section_content /
	Image_preview $mol_image
		uri <= option_image_uri \
	Image_upload $mol_button_open
		title @ \Image
		files? <=> option_image_files? /
	Image_remove $mol_button_minor
		title @ \Remove Image
		click? <=> remove_image? null
	Controls $mol_row
		sub /
			<= Text $mol_string_button
				hint @ \Write your option
				value? <=> option_text? \
			<= Checkbox $mol_check_box
				title @ \Is it correct ?
				checked? <=> is_correct? false
			<= Delete $mol_button_minor
				title @ \Delete
				click? <=> delete? null
